"use client";

import React from "react";
import { ShieldCheck, Wind, Wrench } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  title: "Biyouyumlu Kompozit",
  description: "Doğal diş minesini taklit eden, ışık geçirgenliği yüksek ve doku dostu yeni nesil dolgu materyalleri ile estetik restorasyon.",
  icon: ShieldCheck
}, {
  title: "Katmanlama Tekniği",
  description: "Dişin iç tabakalarından yüzeyine kadar farklı opaklık derecelerinde materyal kullanımıyla sağlanan üç boyutlu derinlik.",
  icon: Wind
}, {
  title: "Fonksiyonel Uyum",
  description: "Isırma ve çiğneme fonksiyonlarını optimize eden, karşı dişlerle mükemmel kapanış sağlayan anatomik formlandırma.",
  icon: Wrench
}];
function AnimatedFeature({
  feature,
  index
}: {
  feature: typeof features[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="134124" ref={ref} data-index={index} className={cn("transition-all duration-1000 ease-out h-full", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
    transitionDelay: `${index * 200}ms`
  }}>
      <Card className="h-full bg-white/40 backdrop-blur-md border-primary/10 shadow-sm hover:bg-white/60 transition-colors duration-500 rounded-sm">
        <CardHeader className="pb-4">
          <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/5 border border-primary/10">
            <feature.icon className="w-8 h-8 text-primary stroke-[1]" />
          </div>
          <CardTitle className="text-xl font-serif font-medium tracking-wide text-foreground">
            {feature.title}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground leading-relaxed font-light">
            {feature.description}
          </p>
        </CardContent>
      </Card>
    </div>;
}
export default function ProtectionTechniques() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="dolgu-işlemi-detayları" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden relative">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-secondary)_0%,transparent_40%)] opacity-30 pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div ref={headerRef} className={cn("max-w-3xl mb-20 transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <span className="text-xs md:text-sm uppercase tracking-[0.3em] text-primary mb-6 block font-medium">
            Klinik Hassasiyet
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light leading-tight text-foreground">
            Modern Dolgu Teknikleri <br className="hidden md:block" />
            <span className="text-primary italic font-normal">Ve Estetik Bütünlük</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-16">
          {features.map((feature, index) => <AnimatedFeature key={index} feature={feature} index={index} />)}
        </div>
      </div>
    </section>;
}